export const GET_CUSTOMERS_STARTED = 'GET_CUSTOMERS_STARTED';
export const GET_CUSTOMERS_SUCCESS = 'GET_CUSTOMERS_SUCCESS';
export const GET_CUSTOMERS_ERROR = 'GET_CUSTOMERS_ERROR';